import { render } from "./ReportsPageTableColumnRecordsNumber.vue?vue&type=template&id=fdb99b48&ts=true"
import script from "./ReportsPageTableColumnRecordsNumber.vue?vue&type=script&lang=ts"
export * from "./ReportsPageTableColumnRecordsNumber.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__